export default "__VITE_PUBLIC_ASSET__b3bef05b__"